var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0868 8.19281C11.3378 8.6948 12.2712 9.36394 12.979 10.151C13.1576 11.4254 12.1615 12.3598 11.2511 12.9335C9.09389 13.3148 6.02961 12.0403 3.4946 9.50535C0.95959 6.97009 -0.314758 3.90603 0.066447 1.74879C0.640136 0.838444 1.57453 -0.157725 2.849 0.0209776C3.63601 0.72897 4.30525 1.66241 4.80724 2.9135C4.89076 3.12178 4.84303 3.35946 4.69031 3.52392C4.43984 3.79367 3.98691 4.24823 3.28838 4.83451C3.11246 4.98218 3.0696 5.23446 3.18185 5.43481C3.66952 6.30516 4.30401 7.14745 5.07842 7.92193C5.85246 8.69598 6.6958 9.33169 7.5648 9.82071C7.76535 9.93353 8.01831 9.89058 8.16605 9.71408C8.75196 9.0143 9.2063 8.56091 9.47605 8.31024C9.64052 8.15723 9.8783 8.10941 10.0867 8.19302L10.0868 8.19281Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelImg);
export default __webpack_public_path__ + "static/media/telImg.3e415fc05b5a6522686563b16abd746f.svg";
export { ForwardRef as ReactComponent };